export default __webpack_public_path__ + "static/media/product.04933cbc.png";